import React, { useState } from "react";
import { api, formatError } from "../lib/api.js";

function Input({ label, value, onChange, testid }) {
  return (
    <label className="block">
      <span className="text-[10px] uppercase tracking-widest text-[#6C757D]">{label}</span>
      <input value={value} onChange={(e) => onChange(e.target.value)} className="w-full mt-0.5 px-2 py-1.5 border border-gray-300 rounded-sm text-sm" data-testid={testid} />
    </label>
  );
}

/**
 * Dialog to create a new task linked to a service case.
 * Extracted from ServiceCaseDetailPage.jsx in iteration 42 so the same
 * dialog can be reused by other detail pages later if needed.
 */
export default function NewTaskDialog({ caseId, users, onClose, onCreated }) {
  const [form, setForm] = useState({
    title: "",
    description: "",
    responsible_user_id: "",
    responsible_department: "Aftersales",
    priority: "Normal",
    deadline: new Date(Date.now() + 24 * 3600 * 1000).toISOString().slice(0, 16),
  });
  const [error, setError] = useState("");
  const submit = async () => {
    setError("");
    try {
      await api.post("/tasks", {
        ...form,
        service_case_id: caseId,
        deadline: new Date(form.deadline).toISOString(),
      });
      onCreated();
    } catch (e) {
      setError(formatError(e.response?.data?.detail));
    }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div className="bg-white rounded-md shadow-xl w-full max-w-md" onClick={(e) => e.stopPropagation()} data-testid="new-task-dialog">
        <div className="px-5 py-3 border-b border-gray-200"><h2 className="font-heading text-lg font-bold">New task</h2></div>
        <div className="p-5 space-y-3">
          <Input label="Title *" value={form.title} onChange={(v) => setForm({ ...form, title: v })} testid="task-title" />
          <label className="block">
            <span className="text-[10px] uppercase tracking-widest text-[#6C757D]">Responsible *</span>
            <select value={form.responsible_user_id} onChange={(e) => setForm({ ...form, responsible_user_id: e.target.value })} className="w-full mt-0.5 px-2 py-1.5 border border-gray-300 rounded-sm text-sm" data-testid="task-responsible">
              <option value="">Select…</option>
              {users.filter((u) => !u.deactivated).map((u) => <option key={u.id} value={u.id}>{`${u.name} (${u.role})`}</option>)}
            </select>
          </label>
          <Input label="Department" value={form.responsible_department} onChange={(v) => setForm({ ...form, responsible_department: v })} />
          <label className="block">
            <span className="text-[10px] uppercase tracking-widest text-[#6C757D]">Priority</span>
            <select value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })} className="w-full mt-0.5 px-2 py-1.5 border border-gray-300 rounded-sm text-sm">
              <option>Low</option><option>Normal</option><option>High</option><option>Critical</option>
            </select>
          </label>
          <label className="block">
            <span className="text-[10px] uppercase tracking-widest text-[#6C757D]">Deadline *</span>
            <input type="datetime-local" value={form.deadline} onChange={(e) => setForm({ ...form, deadline: e.target.value })} className="w-full mt-0.5 px-2 py-1.5 border border-gray-300 rounded-sm text-sm" />
          </label>
          <label className="block">
            <span className="text-[10px] uppercase tracking-widest text-[#6C757D]">Description</span>
            <textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="w-full mt-0.5 px-2 py-1.5 border border-gray-300 rounded-sm text-sm h-16" />
          </label>
          {error && <div className="px-3 py-2 bg-[#F8D7DA] text-[#721C24] rounded-sm text-sm">{error}</div>}
        </div>
        <div className="px-5 py-3 border-t border-gray-200 flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 text-sm border border-gray-300 rounded-sm hover:bg-[#F4F6F8]">Cancel</button>
          <button onClick={submit} className="px-4 py-2 text-sm bg-[#1F3864] hover:bg-[#142542] text-white rounded-sm" data-testid="task-submit">Create</button>
        </div>
      </div>
    </div>
  );
}
